export default function Tooltip({ content, children }) {
    return (
        <div className="menu-item shrink-0 xl:!w-[9%] group relative flex justify-center transition-all duration-300 ease-in-out border border-transparent border-1 hover:border-is2-gray-100 rounded">
            {children}
            <span className="ml-6 tooltip absolute top-6 -right-[264px] bottom-2 scale-0 transition-all text-white bg-is2-blue-500 rounded-bl-[24px] shadow rounded-br-[24px] rounded-tr-[24px] px-5 pb-5 pt-4 text-sm group-hover:scale-100 w-[245px] z-20 h-fit">{content}</span>
        </div>
    );
}
